// Import Vue
import Vue from 'vue';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

import SHMUconf from './SHMUconf'

import VueGtm from '@gtm-support/vue2-gtm'

Vue.use(VueGtm, {
  id: SHMUconf.GTM_ID,
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: true // Whether or not call trackView in Vue.nextTick
});


// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.scss';
import '../static/shmu/css/shmu.scss';
import '../static/shmu/css/_spacing.scss';

import VueLocalStorage from 'vue-ls';

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, {lodash: lodash });

let options = {
  namespace: 'shmu__'
};
Vue.use(VueLocalStorage, options);

const moment = require('moment-timezone');
moment.tz.setDefault('Europe/Bratislava');

require('moment/locale/sk');
Vue.use(require('vue-moment'), {
  moment
});
Vue.moment().locale('sk');

Vue.mixin({
  methods: {
    notEmptyObject(someObject){
      return Object.keys(someObject).length
    }
  }
})


// Import App Component
import App from '../components/app.vue';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
var app = new Vue({
  el: '#app',
  // pushState: true,
  render: (h) => h(App),

  // Register App Component
  components: {
    app: App
  },
});


app.$f7.on('pageInit', function(page) {

  setTimeout(function() {

    let pageTitle = page.name;
    if (app.$$(page.pageEl).find('.title').length) {
      pageTitle = app.$$(page.pageEl).find('.title').html();
    }

    app.$gtm.trackEvent({
      event: 'pageview',
      page: {
        title : pageTitle,
        path: '/m/#!' + page.router.url,
      }
    });


  }, 200);


});

